import { buildEnumMapProvider } from 'sc-common';
import { ReviewTypeEnum } from 'sc-common/core/services/open-api/main-api-client';

export const reviewTypeEnumMapProvider = buildEnumMapProvider(ReviewTypeEnum, getEnumText, getEnumStyles);

export function getEnumText(value: ReviewTypeEnum): string {

    switch (value) {

        case ReviewTypeEnum.Review:
            return $localize`Review`;

        case ReviewTypeEnum.ReReview:
            return $localize`Re-review`;
    }
}

export function getEnumStyles(status: ReviewTypeEnum): string {

    switch (status) {

        case ReviewTypeEnum.Review:
            return 'success';

        case ReviewTypeEnum.ReReview:
            return 'warning';

        default:
            return '';
    }
}
